import { EncryptionConfig, StorageKeys } from "@afe/encryption";
import { urlConfig } from "./url.config";

export const encryptionConfig: EncryptionConfig = {
    url: `${urlConfig.base.urlCrypto}?gw-app-key=${urlConfig.auth.zupAppKey}`,
    systemCode: "MOB",
};
